import { useState } from 'react'
import Button from '../Buttons/Button'

type Props = {
    copyText: string
}

const ClipboardCopy = ({ copyText }: Props) => {
    const [isCopied, setIsCopied] = useState<boolean>(false);

    const handleCopy = async (content: string) => {
        try {
            await navigator.clipboard.writeText(content);
            setIsCopied(true);
            setTimeout(() => {
                setIsCopied(false);
            }, 2000);
        } catch (error) {
            console.error('Unable to copy to clipboard:', error);
        }
    };

    return (
        <div className='w-full border-2 rounded-sm bg-[#F9F9F9] border-[#E0E0E0]'>
            <div className='p-2 flex justify-between items-center text-[13.78px] h-[3rem]'>
                <input type='text' value={copyText} readOnly className='bg-[#F9F9F9] truncate' />
                {
                    !isCopied
                        ?
                        <Button
                            onClick={() => handleCopy(copyText)}
                            variant='primary'
                            label='Copiar'
                            showIconLeft={false}
                            showIconRight={false}
                            className='!h-[2rem]'
                        />
                        : <span className='text-brand-orange-20 text-llarge px-3 '>¡Copiado!</span>
                }
            </div>
        </div>
    )
}

export default ClipboardCopy